<template lang='pug'>
  header
    v-app-bar.bionic-toolbar(app :height='appBarHeight' color='white' elevate-on-scroll)
      div
        a(href='/')
          v-img.ml-4(src='../assets/bionicmetrics-light.png' max-width='256' v-if='!isMobile')
          v-img.ml-1(src='../assets/simple-light.png' max-width='70' v-if='isMobile')
      v-spacer
      v-row(no-gutters align='center' justify='end')
        request-trial-button(bionicmetrics-id='header' label='Request Trial')
        v-btn.hidden-xs-only(text href='https://app.bionicmetrics.com/signin') Sign In
        v-app-bar-nav-icon(@click='toggleRightSidenav')
    v-navigation-drawer.bionic-sidebar(app clipped right temporary v-model='showDrawer')
      div.d-flex.flex-column.fill-height
        v-subheader Bionic Metrics
        v-btn.sidenav-close-button(text icon @click='toggleRightSidenav')
          v-icon close
        v-list
          v-list-item(@click="go('/')")
            v-list-item-title Home
          v-list-item(href='https://app.bionicmetrics.com/signin')
            v-list-item-title Sign In
          v-divider
          v-list-item(@click="go('/contact')")
            v-list-item-title Contact Us
          v-list-item(@click="go('/feedback')")
            v-list-item-title Feedback
        div.mt-auto
          v-row(justify='center' align='end')
            v-img(src='../assets/bionicmetrics-light.png' max-width='200')
          v-spacer
          v-list
            v-divider
            v-list-item
              v-row(align='end' justify='space-around')
                v-btn(text small @click="go('/terms')") Terms
                v-btn(text small @click="go('/privacy')") Privacy
</template>

<script>
import {mapGetters} from 'vuex';
import Subscribe from './Subscribe';
import RequestTrialButton from './RequestTrialButton';
import router from '../router';

export default {
  created() {
    window.addEventListener('scroll', this.handleScroll);
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  components: {
    RequestTrialButton,
    Subscribe
  },
  name: 'Header',
  computed: {
    appBarHeight() {
      if (this.isMobile) return 70;
      return 120;
    },
    showNormal() {
      return !this.hideOnScroll || this.scrollPosition > 250;
    },
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    },
    ...mapGetters({
      title: 'getTitle',
      hideOnScroll: 'getHideOnScroll'
    })
  },
  methods: {
    toggleRightSidenav() {
      this.showDrawer = !this.showDrawer;
    },
    go(path) {
      this.toggleRightSidenav();
      router.push(path);
    },
    handleScroll() {
      this.scrollPosition = window.scrollY;
    }
  },
  data() {
    return {
      showDrawer: false,
      scrollPosition: 0
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-bar {
  background: linear-gradient(180deg, #ECEFF1, #ffffff);
  background-repeat: no-repeat;;
}

.subscribe {
  padding: 10px;
}

.bionic-toolbar {
  z-index: 10;
}

.bionic-sidebar {
  z-index: 11;
}

.show {
  opacity: 1;
}

.sidenav-close-button {
  position: absolute;
  top: 0;
  right: 0;
}
</style>
